import { render, staticRenderFns } from "./PadreTabellaAnnidata.vue?vue&type=template&id=a0eb3edc&scoped=true"
import script from "./PadreTabellaAnnidata.vue?vue&type=script&lang=js"
export * from "./PadreTabellaAnnidata.vue?vue&type=script&lang=js"
import style0 from "./PadreTabellaAnnidata.vue?vue&type=style&index=0&id=a0eb3edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0eb3edc",
  null
  
)

export default component.exports